// extracted by mini-css-extract-plugin
export default {"AuthContainer-ContentWrapper":"style_AuthContainer-ContentWrapper__ksjZG","AuthContainer-Content":"style_AuthContainer-Content__HKJCM","Content-Header":"style_Content-Header__IfAKD"};